import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import JsonRequest from "../components/jsonRequest";

const AutomaticRenewalPage: React.FC = () => {
    const [data, setData] = useState<any>();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    let platform = queryParams.get('platform');

    useEffect(() => {
        getDetail();
    }, []);

    const getDetail = async () => {
        if (platform === 'ios') {
            platform = 'IOS';
        } else platform = 'ANDROID';
        JsonRequest.rawClient().get(`/common/rich-text`, {
            type: 'RICH_TEXT_AUTOMATIC_RENEWAL',
            deviceType: platform
        })
            .then((resp: any) => resp.json())
            .then(async ({ data }: any) => {
                setData(data);
            });
    };

    return (
        <div style={{ padding: '20px' }}>{data && <div dangerouslySetInnerHTML={{ __html: data }} />}</div>
    );
};

export default AutomaticRenewalPage;